__turbopack_context__.v({
  "alloysLoremIpsum": "case-study-grid-module__Zd6jtG__alloysLoremIpsum",
  "beyondTheBasics": "case-study-grid-module__Zd6jtG__beyondTheBasics",
  "blogGrid": "case-study-grid-module__Zd6jtG__blogGrid",
  "blogGridContainer": "case-study-grid-module__Zd6jtG__blogGridContainer",
  "blogGridEyebrow": "case-study-grid-module__Zd6jtG__blogGridEyebrow",
  "blogGridHeading": "case-study-grid-module__Zd6jtG__blogGridHeading",
  "blogGridTitle": "case-study-grid-module__Zd6jtG__blogGridTitle",
  "button": "case-study-grid-module__Zd6jtG__button",
  "buttonRow": "case-study-grid-module__Zd6jtG__buttonRow",
  "cards": "case-study-grid-module__Zd6jtG__cards",
  "carousel": "case-study-grid-module__Zd6jtG__carousel",
  "case-study-grid-swiper": "case-study-grid-module__Zd6jtG__case-study-grid-swiper",
  "caseStudyGrid": "case-study-grid-module__Zd6jtG__caseStudyGrid",
  "chevronLeftLarge": "case-study-grid-module__Zd6jtG__chevronLeftLarge",
  "chevronRightLarge": "case-study-grid-module__Zd6jtG__chevronRightLarge",
  "chevronRightSmall": "case-study-grid-module__Zd6jtG__chevronRightSmall",
  "container": "case-study-grid-module__Zd6jtG__container",
  "content": "case-study-grid-module__Zd6jtG__content",
  "contentCarousel": "case-study-grid-module__Zd6jtG__contentCarousel",
  "contentGroup": "case-study-grid-module__Zd6jtG__contentGroup",
  "contentImg": "case-study-grid-module__Zd6jtG__contentImg",
  "contentText": "case-study-grid-module__Zd6jtG__contentText",
  "descriptionCarousel": "case-study-grid-module__Zd6jtG__descriptionCarousel",
  "dieCastingResources": "case-study-grid-module__Zd6jtG__dieCastingResources",
  "dots": "case-study-grid-module__Zd6jtG__dots",
  "grid": "case-study-grid-module__Zd6jtG__grid",
  "navigation": "case-study-grid-module__Zd6jtG__navigation",
  "navigationWrapper": "case-study-grid-module__Zd6jtG__navigationWrapper",
  "nextButton": "case-study-grid-module__Zd6jtG__nextButton",
  "overviewGrid": "case-study-grid-module__Zd6jtG__overviewGrid",
  "pagination": "case-study-grid-module__Zd6jtG__pagination",
  "paginationButton": "case-study-grid-module__Zd6jtG__paginationButton",
  "paginationButton1": "case-study-grid-module__Zd6jtG__paginationButton1",
  "paginationDotIcon": "case-study-grid-module__Zd6jtG__paginationDotIcon",
  "paginationDotIcon1": "case-study-grid-module__Zd6jtG__paginationDotIcon1",
  "paginationDotIcon2": "case-study-grid-module__Zd6jtG__paginationDotIcon2",
  "paginationDotIcon3": "case-study-grid-module__Zd6jtG__paginationDotIcon3",
  "paginationWrapper": "case-study-grid-module__Zd6jtG__paginationWrapper",
  "prevButton": "case-study-grid-module__Zd6jtG__prevButton",
  "resourceCarouselTitle": "case-study-grid-module__Zd6jtG__resourceCarouselTitle",
  "resourceGrid": "case-study-grid-module__Zd6jtG__resourceGrid",
  "resourceGridContainer": "case-study-grid-module__Zd6jtG__resourceGridContainer",
  "resourceGridTitle": "case-study-grid-module__Zd6jtG__resourceGridTitle",
  "sentencesAboutCompany": "case-study-grid-module__Zd6jtG__sentencesAboutCompany",
  "slide": "case-study-grid-module__Zd6jtG__slide",
  "swiper-wrapper": "case-study-grid-module__Zd6jtG__swiper-wrapper",
  "title": "case-study-grid-module__Zd6jtG__title",
  "viewAll": "case-study-grid-module__Zd6jtG__viewAll",
});
